// frontend/src/utils/constants.js
//
// Site-wide fallback values. These are ONLY used when the backend/database
// hasn't provided a value yet for the current project — as soon as the API
// response includes the real field, that value is shown instead.
//
// Backend fields expected on the `/project-by-domain` response:
//   - data.phone            -> contact phone number (e.g. "+918069368300")
//   - data.footer.agentRera -> channel partner's own RERA agent number
//                              (e.g. "WBRERA/A/KOL/2024/000405")

// Shown for Call/WhatsApp buttons, the footer contact link, and the SEO
// schema until a project sets its own `phone` in the database.
export const DEFAULT_PHONE = "+918069368300";

// Shown below the "Authorized Channel Partner" logo in the footer until a
// project sets its own `footer.agentRera` in the database.
export const DEFAULT_AGENT_RERA = "WBRERA/A/KOL/2024/000405";

/**
 * Formats a raw phone number ("+918069368300", "918069368300",
 * "8069368300") into a readable "+91 8069368300" style string.
 */
export function formatPhoneDisplay(raw) {
  const digits = (raw || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length === 12 && digits.startsWith("91")) {
    return `+91 ${digits.slice(2)}`;
  }
  if (digits.length === 10) {
    return `+91 ${digits}`;
  }
  return raw.startsWith("+") ? raw : `+${digits}`;
}

/** Builds a "tel:+918069368300" href from a raw phone number. */
export function telHref(raw) {
  const digits = (raw || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.length === 10) return `tel:+91${digits}`;
  return `tel:+${digits}`;
}

/** Builds a wa.me-ready phone string (digits only, no "+") from raw input. */
export function waDigits(raw) {
  const digits = (raw || "").replace(/\D/g, "");
  if (digits.length === 10) return `91${digits}`;
  return digits;
}
